import React from 'react';
import { useTranslation } from "react-i18next";
import { DropDownButton } from '@progress/kendo-react-buttons';
import { useHistory, useLocation } from 'react-router-dom';

export default function NavigableFarms({ farmId }) {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    // Cargar del localStorage si no viene del estado de navegación
    const initialSelected = location.state?.selected || sessionStorage.getItem('selectedItem') || 'Redirecciones';
    const [selectedItem, setSelectedItem] = React.useState(initialSelected);

    // Guardar en localStorage si cambia
    React.useEffect(() => {
        sessionStorage.setItem('selectedItem', selectedItem);
    }, [selectedItem]);

    const routes = {
        [t('Farm_Details_Details')]: '/Farms/:farmId/Details/',
        [t('Farm_Details_GeneralInformation')]: '/Farms/:farmId/GeneralInformation/',
        [t('Farm_Details_Locations')]: '/Farms/:farmId/Locations/',
        [t('Farm_Details_StoragePoints')]: '/Farms/:farmId/StoragePoints/',
        [t('Farm_Details_Groups')]: '/Farms/:farmId/Groups/',
        [t('Farm_Details_Contacts')]: '/Farms/:farmId/Contacts/',
        [t('Farm_Details_Orders')]: '/Farms/:farmId/Orders/',
        [t('Farm_Details_Movements')]: '/Farms/:farmId/Movements/',
        [t('Farm_Details_FeedReceipts')]: '/Farms/:farmId/FeedReceipts/',
        [t('Farm_Details_Tasks')]: '/Farms/:farmId/Tasks/'
    };

    const menuItems = Object.keys(routes).map(text => ({ text }));

    const handleItemClick = (e) => {
        const selected = e.item.text;
        setSelectedItem(selected);

        let route = routes[selected];

        if (route && farmId) {
            // Si la ruta contiene ':farmId', reemplázala por el valor real
            if (route.includes(':farmId')) {
                route = route.replace(':farmId', farmId);
                history.push({
                    pathname: route,
                    state: { selected }
                });
            } else {
                // Agrega el farmId al final en las otras rutas
                history.push({
                    pathname: `${route}${farmId}`,
                    state: { selected }
                });
            }
        }
    };
    return (
        <div>
            <div className="col-xs-12 col-sm-6 example-col">
                <div className="buttons-container">
                    <div className="col-xs-12 col-sm-6 example-col">
                        <DropDownButton
                            text={selectedItem}
                            items={menuItems}
                            onItemClick={handleItemClick}
                            themeColor="primary"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
